import core from '../../common/lib/core.js';
import viewSelectSkrillAccountCreater from '../../payment/lib/view-selectskrillaccount.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const create = core.create;
const classnameShow = 'u-show';
const classnameHide = 'u-hide';
const notvalidClass = 'input-wrap__error';
let paymentMethodId = null;
let textkeysObj = {};
let elements = {
	wrapSkrillAccount: null,
	wrapSkrillEmail: null,
	viewSelectSkrillAccount: null,
	wrap: null
};
let userInput = {
	allvalid: false
};

function createDiv(className) {
	return create({
		type: 'div',
		class: className
	});
}

function createLabel(className) {
	return create({
		type: 'label',
		class: className
	});
}

function createSmall(txt) {
	const elm = create({
		type: 'small',
		class: 'input-wrap__error-display payment__feedback grid-u-sm-1 u-hide'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createLegend(txt) {
	const elm = create({
		type: 'legend',
		class: 'legend'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createInputCode(placeholder, inputType) {
	return create({
		type: 'input',
		class: 'js-payment__input-skrill-email payment__input-skrill-email input-wrap__input',
		name: 'code',
		'input-type': inputType,
		placeholder
	});
}

function show(elm) {
	core.removeClass(elm, classnameHide);
	core.addClass(elm, classnameShow);
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function selectExistingAccount() {
	//hide feedback errors on change of dropdown
	hide(elements.emailFeedBack);
	markValid(elements.emailInput, true);
	const selectAccountElement = getSelectedOption(elements.viewSelectSkrillAccount.wrap);
	if (selectAccountElement.getAttribute('add')) {
		elements.emailInput.focus();
		elements.emailInput.placeholder = textkeysObj['skrill-email-placeholder'];
		elements.emailInput.value = '';
	} else {
		setInputValues(selectAccountElement);
	}
}

function setInputValues(p) {
	elements.emailInput.placeholder = p.text;
	elements.emailInput.value = p.text;
}

function getSelectedOption(selectElement) {
	const index = Boolean((selectElement && selectElement.options) && (selectElement.selectedIndex || selectElement.selectedIndex === '0' || selectElement.selectedIndex === 0));
	const elm = (index ? selectElement.options[selectElement.selectedIndex] : null);
	return elm;
}

function getFormInput() {
	const em = core.trailspace(elements.emailInput.value || null);
	return { em, paymentMethodId };
}

function isValidEmail(email) {
	const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

function changeHandler(e) {
	const cb = function change(p) {
		p.e.preventDefault();
		p.e.stopPropagation();
		const skrillAccountOptions = elements.viewSelectSkrillAccount.wrap.options;
		if (p.elm === elements.emailInput) {
			if (elements.emailInput.value === '' && skrillAccountOptions.length > 0 &&
				elements.emailInput.placeholder === skrillAccountOptions[skrillAccountOptions.selectedIndex].text) {
				elements.emailInput.value = elements.emailInput.placeholder;
				markValid(elements.emailInput, true);
				hide(elements.emailFeedBack);
			} else if (isValidEmail(elements.emailInput.value)) {
				markValid(elements.emailInput, true);
				hide(elements.emailFeedBack);
			} else {
				markValid(elements.emailInput, false);
				show(elements.emailFeedBack);
			}
		}
	};
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked*/
	core.handle(e, '.js-payment__input-skrill-email', cb, true);
}

function addListeners() {
	core.addListener(elements.wrap, 'change', changeHandler);
}

function markValid(element, valid) {
	if (valid) {
		core.removeClass(element, notvalidClass);
	} else {
		core.addClass(element, notvalidClass);
	}
}

export default {
	create() {
		textkeysObj = viewTextkeys.depositflow();
		elements.viewSelectSkrillAccount = viewSelectSkrillAccountCreater.create({
			callbackonmainevent: selectExistingAccount
		});
		elements.wrap = elements.wrap || create('div', 'payments-wrap-skrill');
		elements.wrapSkrillAccount = elements.wrapSkrillAccount || createDiv('js-payments__fieldset-wrap-skrill-account payments__fieldset-wrap-skrill-account custom-select u-relative u-mb2');
		elements.wrapSkrillEmail = elements.wrapSkrillEmail || createDiv('js-payments__fieldset-wrap-skrill-email payments__fieldset-wrap-skrill-email input-wrap u-relative u-mb2');

		//create Account Section
		elements.accountLabel = elements.accountLabel || createLabel('payment__label-cn-accountLabel');
		elements.accountTitle = elements.accountTitle || createLegend(textkeysObj['skrill-select-account']);
		elements.accountLabel.appendChild(elements.accountTitle);
		elements.accountLabel.appendChild(elements.viewSelectSkrillAccount.wrap);
		elements.wrapSkrillAccount.appendChild(elements.accountLabel);

		//create email Section
		elements.emailLabel = elements.emailLabel || createLabel('payment__label-cn-emailLabel');
		elements.emailTitle = elements.emailTitle || createLegend(textkeysObj['skrill-enter-email']);
		elements.emailInput = elements.emailInput || createInputCode(textkeysObj['skrill-email-placeholder'], 'email');
		elements.emailFeedBack = elements.emailFeedBack || createSmall(textkeysObj['skrill-email-validation-error-feedback']);
		elements.emailLabel.appendChild(elements.emailTitle);
		elements.emailLabel.appendChild(elements.emailInput);
		elements.emailLabel.appendChild(elements.emailFeedBack);
		elements.wrapSkrillEmail.appendChild(elements.emailLabel);

		elements.wrap.appendChild(elements.wrapSkrillAccount);
		elements.wrap.appendChild(elements.wrapSkrillEmail);
		addListeners();

		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			update(state) {
				if (state.paymentmethods && state.paymentmethods.selected) {
					paymentMethodId = state.paymentmethods.selected.id;
				}
				const skrillAccountDataExists = Boolean((state && state.fetch_methoddetails) && (Array.isArray(state.fetch_methoddetails.accounts) && state.fetch_methoddetails.accounts.length > 0));
				if (state && state.fetch_methoddetails) {
					/* if there are accounts saved then populate and show skrill account. */
					if (skrillAccountDataExists) {
						show(elements.wrapSkrillAccount);
						elements.viewSelectSkrillAccount.update(state);
						setInputValues(getSelectedOption(elements.viewSelectSkrillAccount.wrap));
					}
				} else if (!state.submit_payment) {
					hide(elements.wrapSkrillAccount);
				}
			},
			evalInput() {
				const formInput = getFormInput();
				let finalInput = null;
				if (!isValidEmail(formInput.em)) {
					markValid(elements.emailInput, false);
					show(elements.emailFeedBack);
					userInput.allvalid = false;
					return null;
				}
				finalInput = formInput;
				return finalInput;
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				 Otherwise the '.dim' element will remain on the parent */
				//removeListeners(elements.wrap, handler, mainEventType);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view_skrill:219');
				return null;
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-skrill.js